import { lazy, Suspense } from "react";
import { Loading } from "../sharedComponents";
const Dashboard = lazy(() =>
  import("../pages/Dashboard/Dashboard")
);
const Branch = lazy(() =>
  import("../pages/Branch/Branch")
);
const User = lazy(() =>
  import("../pages/User/Users")
);
const Coordinator = lazy(() =>
  import("../pages/Coordinator/Coordinator")
);
const Teacher = lazy(() =>
  import("../pages/Teacher/Teacher")
);
const Profil = lazy(() =>
  import("../pages/Profile/Profile")
);
const Register = lazy(() =>
  import("../pages/Course/Register")
);
const CourseDetail = lazy(() =>
  import("../pages/Course/Detail")
);
const MyResponsibleCourses = lazy(() =>
  import("../pages/Course/MyResponsibleCourses")
);
const MyCourses = lazy(() =>
  import("../pages/Course/MyCourses")
);
const Tickets = lazy(() =>
  import("../pages/Ticket/Ticket")
);
const Notices = lazy(() =>
  import("../pages/Notice/Notice")
);
const Absences = lazy(() =>
  import("../pages/Absences/Absences")
);
const Report = lazy(() =>
  import("../pages/Report/Report")
);
const Statistic = lazy(() =>
  import("../pages/Statistic/Statistic")
);


export const roles = [
  "Süper Admin",
  "Öğretmen",
  "Öğrenci",
  "Koordinatör",
];

export const privateRoutes = [
  {
    path: "/",
    component: (
      <Suspense fallback={<Loading />}>
        <Dashboard />
      </Suspense>
    ),
    roles: [...roles],
  },
   {
    path: "/branslar",
    component: (
      <Suspense fallback={<Loading />}>
        <Branch />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
   {
    path: "/egitmenler",
    component: (
      <Suspense fallback={<Loading />}>
        <Teacher />
      </Suspense>
    ),
    roles: ["Süper Admin","Koordinatör"],
  },
  {
    path: "/koordinatorler",
    component: (
      <Suspense fallback={<Loading />}>
        <Coordinator />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/kullanicilar",
    component: (
      <Suspense fallback={<Loading />}>
        <User />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/kayit-ol",
    component: (
      <Suspense fallback={<Loading />}>
        <Register />
      </Suspense>
    ),
    roles: ["Süper Admin","Öğrenci"],
  },
  {
    path: "/kurs-detay",
    component: (
      <Suspense fallback={<Loading />}>
        <CourseDetail />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/sorumlu-kurslarim",
    component: (
      <Suspense fallback={<Loading />}>
        <MyResponsibleCourses />
      </Suspense>
    ),
    roles: ["Öğretmen","Koordinatör"],
  },
  {
    path: "/kayitli-kurslarim",
    component: (
      <Suspense fallback={<Loading />}>
        <MyCourses />
      </Suspense>
    ),
    roles: ["Öğrenci"],
  },
  {
    path: "/devamsizliklar",
    component: (
      <Suspense fallback={<Loading />}>
        <Absences />
      </Suspense>
    ),
    roles: ["Öğrenci","Öğretmen","Süper Admin","Koordinatör"],
  },
   {
    path: "/duyurular",
    component: (
      <Suspense fallback={<Loading />}>
        <Notices />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/geri-bildirimler",
    component: (
      <Suspense fallback={<Loading />}>
        <Tickets />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
   {
    path: "/raporlama",
    component: (
      <Suspense fallback={<Loading />}>
        <Report />
      </Suspense>
    ),
    roles: ["Süper Admin","Koordinatör"],
  },
  {
    path: "/istatistik",
    component: (
      <Suspense fallback={<Loading />}>
        <Statistic />
      </Suspense>
    ),
    roles: ["Süper Admin"],
  },
  {
    path: "/profil",
    component: (
      <Suspense fallback={<Loading />}>
        <Profil />
      </Suspense>
    ),
    roles: ["Süper Admin","Öğrenci","Öğretmen","Koordinatör"],
  },
  ];
